'use strict';

var Entry = require('components/sidebar/models/sidebar_entry');
var Theme = require('utils/theme/theme_controller');

var SidebarEntryView = Marionette.ItemView.extend({
    model: Entry.Model,
    tagName: 'li',
    template: require('components/sidebar/templates/sidebar_element'),

    attributes: function () {
        var isLabel = this.model.get('url') === '' && this.model.get('subs').length == 0;
        return { class: isLabel ? 'text-muted menu-title' : 'has_sub' };
    },
});

var SidebarView = Marionette.CompositeView.extend({
    template: require('components/sidebar/templates/sidebar'),
    childView: SidebarEntryView,
    childViewContainer: 'ul',
    id: 'sidebar-menu',

    onAttach: function () {
        Theme.InitializeSidemenu();
    },

    onRender: function () {
        Theme.InitializeSidemenu();
    },
});

module.exports = SidebarView;
